var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "newsletter" }, [
    _c("div", { staticClass: "content-newsletter" }, [
      _c("div", [
        _c(
          "p",
          {
            class: [
              "content-topic",
              { "drc-topic": _vm.newsletter.platform === _vm.PLATFORMS.DRC },
              { "gop-topic": _vm.newsletter.platform === _vm.PLATFORMS.GOP }
            ]
          },
          [
            _vm._v(
              " " +
                _vm._s(
                  _vm.newsletter.topic.trim() !== ""
                    ? _vm.newsletter.topic
                    : _vm.$t("controlPanel.landingPage.exampleTopic")
                ) +
                " "
            )
          ]
        ),
        _c(
          "p",
          {
            class: [
              "content-title",
              { "drc-title": _vm.newsletter.platform === _vm.PLATFORMS.DRC },
              { "gop-title": _vm.newsletter.platform === _vm.PLATFORMS.GOP }
            ]
          },
          [
            _vm._v(
              " " +
                _vm._s(
                  _vm.newsletter.title.trim() !== ""
                    ? _vm.newsletter.title
                    : _vm.$t("controlPanel.landingPage.exampleTitle")
                ) +
                " "
            )
          ]
        )
      ]),
      _c("div", { staticClass: "message" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.newsletter.message.trim() !== ""
                ? _vm.newsletter.message
                : _vm.$t("controlPanel.landingPage.exampleMessage")
            ) +
            " "
        )
      ])
    ]),
    _c("button", { staticClass: "button-redirect" }, [
      _vm._v(
        " " +
          _vm._s(
            _vm.newsletter.redirectionButtonText.trim() !== ""
              ? _vm.newsletter.redirectionButtonText
              : _vm.$t("controlPanel.landingPage.exampleButtonRedirect")
          ) +
          " "
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }